<template>
  <section>
    <div class="container">
      <!-- Search Filters -->
      <div class="job-filters d-flex align-items-center">
        <div class="form-group first mr-2">
          <!--  <input typer="text" class="form-control" placeholder="Keywords" /> -->
          <v-select
            placeholder="Keywords"
            :options="['test', 'test1']"
            :clearable="false"
          ></v-select>
        </div>
        <div class="form-group w-25 mr-2">
          <!--  <input typer="text" class="form-control" placeholder="Location" /> -->
          <v-select
            placeholder="Location"
            :options="['test3', 'test4']"
            :clearable="false"
          ></v-select>
        </div>
        <div class="form-group w-25">
          <select class="form-control pr-3">
            <option value="0">Employment type</option>
            <option>Employment</option>
            <option>Self-employment</option>
          </select>
        </div>
        <div class="form-group ml-auto d-flex">
          <button class="btn btn-success ml-auto">Apply Filters</button>
        </div>
      </div>
      <!-- End Search Filters -->
    </div>
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered  modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Comstream office location</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="map-responsive">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.505558647455!2d23.3806615154147!3d42.6294411791697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa87b60495d239%3A0x67492f3436effc34!2sComstream%20OOD!5e0!3m2!1sbg!2sbg!4v1601276793032!5m2!1sbg!2sbg"
                width="600"
                height="450"
                frameborder="0"
                style="border:0;"
                allowfullscreen=""
                aria-hidden="false"
                tabindex="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {},
  methods: {
    ...mapActions(['fetchAllJobResults']),
  },
  computed: { ...mapGetters(['allSearchJobResults']) },
  mounted() {
    this.fetchAllJobResults();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';
.modal-header {
  text-align: center;
  .modal-title {
    font-size: 28px;
    text-align: center;
    display: block;
    margin: 0 auto;
    width: 100%;
  }
}

.map-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.map-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

.job-filters {
  .vs--searchable .vs__dropdown-toggle {
    height: 38px;
  }
  .vs__search {
    color: rgb(73, 80, 87);
    padding-top: 2px !important;
  }
  .first {
    width: 35%;
  }
}

.list-unstyled.job-list {
  li {
    border-bottom: 1px solid #ddd;
    margin-bottom: 12px;
    padding: 15px 0;

    figure {
      width: 85px;
      height: 85px;
      margin: 0 12px 0 0;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 85px;
        object-fit: cover;
        border: 1px solid #ddd;
        border-radius: 8px;
      }
    }
    .text {
      font-family: $font-family-sans-lato;
      .job-title {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        color: $color-card-title;
        display: block;
        margin-bottom: 3px;
      }

      .company {
        color: $color-orange;
        display: block;
        font-size: 14px;
        margin-bottom: 8px;
      }

      a {
        display: block;
        text-decoration: none;
      }

      .type {
        background: #f05a00;
        display: inline-block;
        padding: 2px 12px;
        color: #fff;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 700;
        margin-right: 12px;
      }

      .update {
        font-size: 14px;
        color: #666;
      }
    }

    .location {
      font-family: $font-family-sans-lato;
      font-size: 16px;
      color: #888;

      i {
        display: block-inline;
        width: 25px;
      }
    }

    .cloud {
      li {
        border: none;
        margin: 4px 5px;
        padding: 0;
        a {
          color: #555;
          display: block;
          border-radius: 20px;
          text-decoration: none;
          font-size: 11px;
          font-weight: 700;
          background: #f2f2f2;
          padding: 6px 12px;
          text-transform: lowercase;
        }
      }
    }
  }
}

.portal-header {
  font-family: $font-family-sans-lato;
  min-height: 30vh;
  h1 {
    font-size: 31px;
    font-weight: 700;
    margin: 15px 0 8px 0;
  }
  .slogan {
    font-weight: 700;
    font-size: 15px;
    color: #222;
    margin: 50px 0 12px 0;
    display: block;
  }

  p {
    font-size: 15px;
    letter-spacing: 0.5px;
  }

  .list-unstyled {
    margin-top: 28px;
    li {
      font-size: 14px;
      margin-bottom: 12px;
      border-bottom: 1px dashed #ddd;
      padding-bottom: 12px;
      span {
        font-weight: 700;
      }
      a {
        text-decoration: none;
      }
      i {
        display: inline-block;
        width: 20px;
        margin-right: 8px;
        text-align: center;
        color: #777;
      }
    }
  }
}

.job-ad {
  font-family: $font-family-sans-lato;
  h1 {
    font-size: 32px;
    font-weight: 700;
  }
  .location,
  .employment,
  .type {
    margin-right: 20px;
  }
  .list-unstyled {
    list-style: circle;
    margin: 15px 0;
    li {
      margin-left: 30px;
      padding-left: 8px;
    }
  }
}

/* Media queries */

@media only screen and (max-width: 576px) {
  .list-unstyled.job-list {
    border: none;
    li {
      figure {
        display: none;
      }

      .location {
        display: block;
        margin: 12px 0;

        i {
          width: 15px;
        }
      }
    }
  }
}
</style>
